// Feature flag — true = Moons/wallet-only; false = CC-style direct pay-per-image (USD)
// Part B: switched to CC model — pay per image directly, wallet holds real USD store credit.
export const WALLET_ONLY_MODE = false

// Moon pack definitions — matches backend/config/moonConfig.js exactly
// 1 Moon = $0.01 (1 cent) — flat rate, no bonuses
export const MOON_PACKS = [
  { id: 'pack_10',  moons: 1000,  priceCents: 1000,  display: '$10'  },
  { id: 'pack_25',  moons: 2500,  priceCents: 2500,  display: '$25'  },
  { id: 'pack_50',  moons: 5000,  priceCents: 5000,  display: '$50'  },
  { id: 'pack_100', moons: 10000, priceCents: 10000, display: '$100' },
  { id: 'pack_250', moons: 25000, priceCents: 25000, display: '$250' },
  { id: 'pack_500', moons: 50000, priceCents: 50000, display: '$500' },
] as const

export type MoonPackId = typeof MOON_PACKS[number]['id']

// Convert USD dollars to Moons (1 Moon = $0.01)
export function dollarToMoons(dollars: number): number {
  return Math.round(dollars * 100)
}

export const MOON_TIP_PRESETS = [5, 10, 25, 50, 100] as const

export const CURRENCY_NAME = 'Moons'
export const CURRENCY_SYMBOL = '' // No currency symbol — CC-style (real dollars, no coin)
export const CURRENCY_NAME_SINGULAR = 'Moon'

export function formatMoons(amount: number): string {
  return `${CURRENCY_SYMBOL} ${amount.toLocaleString()}`
}

export function formatMoonsLong(amount: number): string {
  return `${amount.toLocaleString()} ${amount === 1 ? CURRENCY_NAME_SINGULAR : CURRENCY_NAME}`
}

// === PER-MESSAGE MOON COST ===
// When enabled, each fan message costs MESSAGE_MOON_COST moons
// Set MESSAGE_MOON_COST_ENABLED to false to completely disable this feature
export const MESSAGE_MOON_COST_ENABLED = false // CC-style: messaging is free
export const MESSAGE_MOON_COST = 100  // moons per message ($1.00)
